<template>
  <div id="footer"
       style="margin-top:69px; min-width: 1220px;">

    <div class="nav">
      <p class="companyNm">友情链接</p>
      <div class="navSub">
        <a target="_blank"
           href="http://www.gmw.cn/">光明网</a>
        <span class="line">｜</span>
        <a target="_blank"
           href="http://www.xinhuanet.com/politics">新华时政</a><span class="line">｜</span>
        <!-- <a target="_blank"
           href="https://politics.gmw.cn">光明网时政</a><span class="line">｜</span> -->

        <a target="_blank"
           href="http://www.qiusuo.net.cn">中国求索网</a>

        <!-- <a target="_blank" href="http://child.wsbgt.com/">少儿多媒体图书馆</a><span class="line">｜</span>

            <a target="_blank" href="http://www.qiusuo.net.cn/">中国求索网</a> -->

      </div>
    </div>
    <div class="copyRight">
      <p>技术支持QQ：100035800　客服专线：400-8989-889　客户端IP：{{ip}}　邮箱:market@bjadks.com <a style="text-decoration: none;" href="https://www.wjx.top/vm/m70kFc3.aspx#" target="_blank" rel="noopener noreferrer">版权申诉</a><a style="text-decoration: none;margin-left: 10px;" href="https://www.wjx.cn/vm/eC9UOTk.aspx#" target="_blank" rel="noopener noreferrer">意见反馈</a></p>
      <p>Copyright © 2004 - 2020 EDU&amp;SUN . All Rights Reserved. 爱迪科森 版权所有 京ICP备11016584号-5 </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ip: '218.68.105.164'

    }
  },
  created () {
    this.getIp()
  },
  methods: {
    getIp () {
      if (localStorage.getItem('localIp')) {
        this.ip = localStorage.getItem('localIp')
        return
      }

      var that = this
      this.getRequest('api/v1/home/GetTrueIp').then(data => {
        if (data.IsSuccess) {
          that.ip = data.Data
          localStorage.setItem('localIp', data.Data)
        }
      })
    },
    getIpAdress (data) {
      var reg = new RegExp(': ' + ',')
      var r = data.match(reg)
      if (r != null) return unescape(r[2])
      return null
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/bottom.vue